import type * as Types from 'app/types/graphql';

import {
  OrderJourneySelectFragmentDoc,
  OrderJourneyItemSelectFragmentDoc,
} from '../fragments/orderJourney.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type OrderJourneyQueryVariables = Types.Exact<{
  input: Types.OrderJourneyInput;
}>;

export type OrderJourneyQueryResponse = {
  orderJourney?: Types.Maybe<
    Pick<Types.OrderJourneyResponse, 'cursor'> & {
      journeys?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.OrderJourney,
              | 'campaignID'
              | 'campaignGroupID'
              | 'campaignGroupName'
              | 'campaignName'
              | 'campaignVariantType'
              | 'date'
              | 'locationPath'
              | 'name'
              | 'orderID'
              | 'pageTitle'
              | 'shopifySessionID'
            > & {
              items?: Types.Maybe<
                Array<
                  Types.Maybe<
                    Pick<
                      Types.OrderJourneyItem,
                      | 'imageURL'
                      | 'productID'
                      | 'productTitle'
                      | 'productVariantID'
                      | 'properties'
                      | 'quantity'
                      | 'title'
                    >
                  >
                >
              >;
            }
          >
        >
      >;
    }
  >;
};

export const OrderJourneyDocument = `
    query OrderJourney($input: OrderJourneyInput!) {
  orderJourney(input: $input) {
    cursor
    journeys {
      ...OrderJourneySelect
    }
  }
}
    ${OrderJourneySelectFragmentDoc}
${OrderJourneyItemSelectFragmentDoc}`;

export const useOrderJourneyQuery = <TData = OrderJourneyQueryResponse, TError = unknown>(
  variables: OrderJourneyQueryVariables,
  options?: UseQueryOptions<OrderJourneyQueryResponse, TError, TData>,
) => {
  return useQuery<OrderJourneyQueryResponse, TError, TData>(
    ['OrderJourney', variables],
    appFetcher<OrderJourneyQueryResponse, OrderJourneyQueryVariables>(
      OrderJourneyDocument,
      variables,
    ),
    options,
  );
};

useOrderJourneyQuery.getKey = (variables: OrderJourneyQueryVariables) => [
  'OrderJourney',
  variables,
];
